//
// Imports
//

import * as BrowserUtilities from "@donutteam/browser-utilities";
import { initialiseForm } from "@donutteam/document-builder-components/build/client.js";

import { RequestBody, ResponseBodySchema } from "../../../../api/routes/v6/users/disable.schemas.js";

//
// Component
//

export function initialiseDisableAccountForm(disableAccountForm: HTMLFormElement)
{
	const apiUrl = BrowserUtilities.ElementClientLib.getStringDataOrThrow(disableAccountForm, "apiUrl");

	const currentPasswordInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(disableAccountForm, `input[name="currentPassword"]`);

	initialiseForm(disableAccountForm,
		async () =>
		{
			const requestBody: RequestBody =
			{
				currentPassword: currentPasswordInput.value,
				requestDeletion: false,
				requestDeletionFeedback: null,
			};

			const response = await fetch(apiUrl + "/v6/users/disable",
				{
					credentials: "include",
					method: "POST",
					headers:
					{
						"Content-Type": "application/json",
					},
					body: JSON.stringify(requestBody),
				});

			const responseBody = ResponseBodySchema.parse(await response.json());

			if (!responseBody.success)
			{
				return {
					restoreInputs: true,
					notices: responseBody.errors.map((error) => ({ type: "warning", message: error.message, dismissible: true })),
				};
			}

			window.location.href = "/account/log-in";

			return {
				restoreInputs: false,
			};
		});

	disableAccountForm.classList.add("initialised");
}

export function initialiseDisableAccountForms()
{
	const disableAccountForms = document.querySelectorAll<HTMLFormElement>(".component-disable-account-form:not(.initialised)");

	console.log("[DisableAccountForm] Initialising " + disableAccountForms.length + " instances...");

	for (const disableAccountForm of disableAccountForms)
	{
		try
		{
			initialiseDisableAccountForm(disableAccountForm);
		}
		catch (error)
		{
			console.error("[DisableAccountForm] Error initialising:", disableAccountForm, error);
		}
	}
}